import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import btnClose from '../../images/common/close.svg';
import {
  Main,
  Header,
  Contents,
  CloseButton,
  CloseButtonImage,
  UpdateButton,
  CancelButton,
} from '../../styles/common/Dialog';
import {
  Dialog,
  BodyBlock,
  EnhancedItemWrapper,
  InfoBody,
  StyledSelect,
  InfoTitle,
  ButtonsWrapper,
  InputWrapper,
} from './styles/GroupDetailDialogStyles';
import CreateGroupDialogUserTable from './CreateGroupDialogUserTable';
import CustomInput from '../Parts/CustomInput';
import createGroup from '../../actions/api/group/createGroup';
import { checkAdminUser } from './functions/GroupDialogUtils';

// TODO: i18n対応
/**
 * 新しいグループを作成するためのダイアログを表示する
 *
 * グループ名の入力欄、タグセットの選択肢、担当者の選択テーブルが含れる。
 * ユーザーはこれらの情報を入力・選択し、新しいグループを追加する
 * 企業管理者が含まれていない場合は、エラーメッセージを表示する。
 *
 * @param {Object[]} allTagSets 企業に紐づく全てのタグセットの配列。
 * @param {function} onClose ダイアログを閉じるための関数。
 */
const CreateGroupDialog = ({ allTagSets, onClose }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const companyAllUsers = useSelector(state => state.group.operators);

  const [inputText, setInputText] = useState('');
  const [selectedTagSet, setSelectedTagSet] = useState();

  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const handleSelectedMembersChange = userIds => {
    setSelectedUserIds(userIds);
  };

  const handleCancelButtonClick = () => {
    onClose();
  };

  const handleCreateButtonClick = () => {
    if (
      !checkAdminUser(selectedUserIds, companyAllUsers, dispatch, formatMessage)
    ) {
      return;
    }

    dispatch(
      createGroup(apiToken, {
        name: inputText,
        tagSetId: selectedTagSet,
        members: selectedUserIds,
      }),
    ).then(() => {
      onClose();
    });
  };

  useEffect(() => {
    if (allTagSets[0]) {
      setSelectedTagSet(allTagSets[0].id);
    }
  }, [allTagSets]);

  return (
    <Main id="createGroupDialog" role="presentation" onClick={() => onClose()}>
      <Dialog role="presentation" onClick={e => e.stopPropagation()}>
        <Contents>
          <Header>
            <div>グループ追加</div>
            <CloseButton
              id="closeButton"
              role="presentation"
              className="button"
              onClick={() => onClose()}
            >
              <CloseButtonImage src={btnClose} alt="close" />
            </CloseButton>
          </Header>
          <BodyBlock>
            <EnhancedItemWrapper>
              <InfoTitle>
                <FormattedMessage id="group.list.header.name" />
              </InfoTitle>
              <InfoBody>
                <InputWrapper>
                  <CustomInput
                    value={inputText}
                    placeholder="グループ名"
                    onChange={e => setInputText(e.target.value)}
                    maxLength={30}
                  />
                </InputWrapper>
              </InfoBody>
            </EnhancedItemWrapper>
            <EnhancedItemWrapper>
              <InfoTitle>タグセット</InfoTitle>
              <InfoBody>
                <StyledSelect
                  id="selectTagSet"
                  onChange={e => {
                    setSelectedTagSet(e.target.value);
                  }}
                >
                  {allTagSets.map(eachTagSet => (
                    <option key={eachTagSet.id} value={eachTagSet.id}>
                      {eachTagSet.name}
                    </option>
                  ))}
                </StyledSelect>
              </InfoBody>
            </EnhancedItemWrapper>
            <EnhancedItemWrapper>
              <InfoTitle>担当者</InfoTitle>
              <CreateGroupDialogUserTable
                onSelectedMembersChange={handleSelectedMembersChange}
              />
            </EnhancedItemWrapper>
          </BodyBlock>
          <ButtonsWrapper>
            <CancelButton onClick={handleCancelButtonClick}>
              キャンセル
            </CancelButton>
            <UpdateButton onClick={handleCreateButtonClick}>追加</UpdateButton>
          </ButtonsWrapper>
        </Contents>
      </Dialog>
    </Main>
  );
};

CreateGroupDialog.propTypes = {
  allTagSets: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CreateGroupDialog;
